import YUSPUtil from '../../util/yusp_util';

import StorageUtil from '../../util/storage_util';
import { AddCartModal } from '../../models/add_cart/modal';
import { AddCartViewModal } from '../../models/add_cart/modal_view';
import { AsCartRepository } from '../../repositories/as_cart_repository';
import { AddCartButtonRequest } from '../../models/add_cart/modal_js_env';
import { TypedEvent } from '../../../core/typed_event';
import { SupplierId } from '../../models/supplier_id';
import { AddCartModalState } from '../../models/add_cart/modal_recommend';
import { Env } from '../../env';
import { CatalogItemCodesWithElementId, doShowRtoaster, RtoasterParameter } from '../../models/rtoaster/rtoaster_utils';
import { RrRepository } from '../../repositories/rr_repository';
import { ModalRecommendContainer } from '../../views/pc/rr_item/modal_recommend_container';
import { setParametersCallBack } from '../../models/add_cart/set_rtoaster_parameter';
import { getSiteTypeValue, isSoloare, SiteType } from '../../models/js_env';
import { AddCartAnalytics } from '../analytics/add_cart_analytics';
import { AsCartItem } from '../../../item/models/large_commercial_pack_env';
import { AnalyticsItems } from '../../models/analytics/analytics_items';
import { AnalyticsItem } from '../../models/analytics/analytics_item';
import { MessageConverter } from '../../util/message_converter';
import { RTOASTER_STATUS } from '../../rtoaster';


/// ローカルストレージカゴお気に入りモーダル非表示キー論理名
const HIDE_CART_FAVORITE_MODAL_KEY = 'HIDE_CART_FAVORITE_MODAL';
/// ローカルストレージカゴお気に入りモーダル非表示の設定値
const HIDE_CART_FAVORITE_MODAL_VALUE = '1';

/// カゴに入れましたモーダル非表示有効日数
const HIDE_CART_FAVORITE_MODAL_DATE_LIMIT = 30;

/// カゴに入れるボタンID
const ADD_CART_BUTTON = 'addCartButton';

/// カゴに入れるモーダルの一定期間非表示チェックボックスID
const ADD_CART_MODAL_VIEW_CHECK_BOX = 'addCartModalViewCheckbox';

const SUPPLIER_ID_ASKUL = 'P00001'

// ソロアリで未ログイン時にカゴ追加する際のエラーコード
const SOLOARE_ADD_CART_NOT_LOGIN_ERROR_CODE = '0';

// Rtoaster.jsで埋め込み箇所のHTMLが書き換えられてしまうため、
// 2回目以降のカゴへ追加を押したときに元のHTMLを復元できるように保持しておく
const MODAL_BASE_HTML = `
        <div id="tr_modal_recommend" style="display:none;" class="tr_modal_recommend">
          <div id="tr_modal_recommend_1"></div>
          <div id="tr_modal_recommend_2"></div>
          <div id="tr_modal_recommend_3"></div>
          <div id="tr_modal_recommend_4"></div>
          <div id="tr_modal_recommend_5"></div>
          <div id="tr_modal_recommend_6"></div>
          <div id="tr_modal_recommend_7"></div>
          <div id="tr_modal_recommend_8"></div>
          <div id="tr_modal_recommend_9"></div>
          <div id="tr_modal_recommend_10"></div>
          <div id="tr_modal_recommend_11"></div>
          <div id="tr_modal_recommend_12"></div>
          <div id="tr_modal_recommend_13"></div>
          <div id="tr_modal_recommend_14"></div>
          <div id="tr_modal_recommend_15"></div>
        </div>`;

const MAX_RETRY_COUNT = 30;
const RETRY_INTERVAL = 100;

export class AddCartModalAction {
  private static asCartRepository: AsCartRepository;
  private static rrRepository: RrRepository;
  static readonly CART_SUBMIT_EVENT = new TypedEvent<AnalyticsItems>();
  static readonly POSITIVE_TRANSITIONS_EVENT = new  TypedEvent<AnalyticsItems>();
  private static state: AddCartModalState;
  static modalBaseHtml = MODAL_BASE_HTML;
  static init() {
    new AddCartAnalytics(); // NOSONAR
    this.state = new AddCartModalState(Env.PAGE);
    this.asCartRepository = new AsCartRepository();
    this.rrRepository = new RrRepository();

    Env.FUNCTIONS['clickAddCart'] = this.clickAddCart.bind(this);

    this.addCartModalViewCheckbox('');
    // YUSP連携 ユーザーID連携
    YUSPUtil.register({
      enableUserId: true
    });
  }

  static setUserId() {
    // YUSP連携 ユーザーID連携
    YUSPUtil.register({
      enableUserId: true
    });
  }

  static bindClickAddCartToWindow() {
    /* AddCartAnalytics()でCART_SUBMIT_EVENTとPOSITIVE_TRANSITIONS_EVENTにカゴ追加トラッキングメソッドを入れる処理がある。
     * 商品詳細とバリエーショ一覧画面の画面用JSファイル（init()）とカゴ追加JSファイル（bindClickAddCartToWindow()）は両方とも即時実行関数となるため、
     * それぞれ初期化されたカゴ追加トラッキングメソッドは別々のスコープにある。
     * よって、ここでAddCartAnalytics()を呼び出し、カゴ追加JSファイルでトラッキングメソッドを初期化する必要がある。*/
    new AddCartAnalytics(); // NOSONAR
    this.state = new AddCartModalState(Env.PAGE);
    this.asCartRepository = new AsCartRepository();
    // かごに入れましたモーダルでRR/Rtoasterの表示に必要
    // 各検索系画面のjsとカゴ追加用のjsは変数スコープが異なるため、ここで変数を定義する必要あり
    this.rrRepository = new RrRepository();
    // カゴへボタン押下時のfunctionをbind
    // メソッドをwindowに外だしするとthisがwindowに指すため、ここでthisをクラスとバインドする必要がある
    Env.FUNCTIONS['clickAddCart'] = this.clickAddCart.bind(this);
  }

  // カゴへボタン押下(windowに公開用)(addEventListenerだと画面が非同期更新された際に再登録が必要になるため)
  private static async clickAddCart(element) {

    const catalogItemCode = (element.dataset.catalogItemCode) ? element.dataset.catalogItemCode : '';
    this.clickAddCartButton(element, '', '', catalogItemCode);
  }

  private static async showRtoasterArea(catalogItemCodesWithElementIds: CatalogItemCodesWithElementId[]) {
    const state = this.state;

    const modalRecommendCatalogItemCodes = catalogItemCodesWithElementIds.filter(catalogItemCodesWithElementId => catalogItemCodesWithElementId.elementId === 'tr_modal_recommend')[0].catalogItemCodes;
    const modalRecommendCarouselItems = await this.rrRepository.getRrItemsDetail(modalRecommendCatalogItemCodes, false, SiteType.SOLOARE);
    state.setModalRecommendAreaItemModel(modalRecommendCarouselItems, 'あわせて購入されている商品');

    // 2回目以降のカゴ追加時のRtoasterAPI送信を可能とする
    RTOASTER_STATUS.isDuringRtoaster = false;
    new ModalRecommendContainer(state.getModel()); // NOSONAR
  }

  static execAddCartButton(
    id: string,
    viewName: string
    ) {
    this.asCartRepository = new AsCartRepository();
    const targetElement = document.getElementById(ADD_CART_BUTTON + '-' + id)

    if(!targetElement) {
      return
    }

    this.clickAddCartButton(targetElement, id, viewName, '');
    this.addCartModalViewCheckbox(id);
  }

  static addCartModalViewCheckbox(
    id: string
  ){
    /// カゴに入れるモーダルの一定期間非表示チェックボックス押下
    var checkBoxId = ADD_CART_MODAL_VIEW_CHECK_BOX;
    if(id) {
      checkBoxId = checkBoxId + '-' + id;
    }
    document.getElementById(checkBoxId)?.addEventListener('click', (e) => {
      const target = e.target as HTMLInputElement;
      if (target.checked) {
        this.checkedAddCartModalViewCheckbox();
      } else {
        this.uncheckedAddCartModalViewCheckbox();
      }
    });
  }

  /// カゴに入れるモーダルの一定期間非表示チェックボックス押下処理
  static checkedAddCartModalViewCheckbox() {
    StorageUtil.setItemAfterDates(
      HIDE_CART_FAVORITE_MODAL_KEY,
      HIDE_CART_FAVORITE_MODAL_VALUE,
      HIDE_CART_FAVORITE_MODAL_DATE_LIMIT
    );
  }

  /// カゴに入れるモーダルの一定期間非表示チェックボックス押下解除処理
  static uncheckedAddCartModalViewCheckbox() {
    localStorage.removeItem(HIDE_CART_FAVORITE_MODAL_KEY);
  }

  /// カゴ投入ボタン押下処理
  private static async clickAddCartButton(
    targetElement: HTMLElement,
    id: string,
    viewName: string,
    catalogItemCode: string
  ) {
    const getClickCartButtonRequest = AddCartModal.createRequestForGetClickCartButtonByNormal(targetElement, viewName);

    if (!getClickCartButtonRequest.quantity) {
      alert('数量は必須入力です')
      return
    }

    /// 集客検索PF.カゴ共通.カゴボタン押下を実行する
    await this.addCart(
      targetElement,
      getClickCartButtonRequest,
      id,
      viewName,
      catalogItemCode
    );
  }

  /// カゴ投入ボタン押下処理実行
  static async addCart(
    targetElement: HTMLElement,
    getClickCartButtonRequest: AddCartButtonRequest,
    id: string,
    viewName: string,
    catalogItemCode: string
  ) {
    // YUSP連携 ADD_TO_CARTイベント
    YUSPUtil.register({
      enableAddToCart: {
        catalogItemCodes: [catalogItemCode || getClickCartButtonRequest.catalogItemCode], // パラメータを優先
        quantities: [getClickCartButtonRequest.quantity]
      }
    });
    /// 集客検索PF.カゴ共通.カゴボタン押下を実行する
    await this.asCartRepository.getClickCartButton(
      getClickCartButtonRequest.supplierId,
      getClickCartButtonRequest.catalogItemCode,
      getClickCartButtonRequest.quantity,
      getSiteTypeValue(),
      AddCartModalAction.getSoloelRcmndFldrIdFromUrl(),
    ).then((result) => {
    /// ポジティブ遷移の計測（PC検索結果画面1ページ目のかご追加）トリガー設定
    this.positiveTransitionsAnalytics(targetElement, getClickCartButtonRequest)

    // TODO R2 カゴ商品追加・更新APIの返却値で共通ヘッダーのカゴエリアの項目（点数、合計金額）を書き換える

    /// サイト区分 = ソロアリ かつ集客検索PF.カゴ共通.カゴボタン押下.isCartRedirectがtrueの場合
    if (isSoloare(Env.SITE_TYPE) && result.isCartRedirect) {
      /// ソロアリフロント画面.DAE01010 カート内商品一覧に遷移する
      window.location.href = result.redirectPath;
      return;
    }

    /// ローカルストレージ.カゴお気に入りモーダル非表示の値を取得する
    const hideCartFavoriteModalValue = StorageUtil.getItemWithExpiration(
      HIDE_CART_FAVORITE_MODAL_KEY
    );

    if (isSoloare(Env.SITE_TYPE) && this.state.getModel().shouldDisplayRecommend && hideCartFavoriteModalValue !== HIDE_CART_FAVORITE_MODAL_VALUE) {
      let modalRecommendId = 'tr_modal_recommend';
      if (document.getElementById('tr_modal_recommend-parent')) {
        // カゴへボタンがある箇所では'tr_modal_recommend-parent'のidは必ず存在する
        // -> 「最近チェックした商品」画面では'tr_modal_recommend-カタログ商品コード-parent'となる
        document.getElementById('tr_modal_recommend-parent')!!.innerHTML!! = this.modalBaseHtml!!;
        // 1回表示されるとdisplayがblockに書き換わっているため、ここでnoneへ戻す
        document.getElementById('tr_modal_recommend-parent')!!.style.display = 'none';
      } else {
        // 「最近チェックした商品」画面では商品ごとなので、一旦クリアする必要はない。noneへ戻す。
        document.getElementById('tr_modal_recommend-' + getClickCartButtonRequest.catalogItemCode + '-parent')!!.style.display = 'none'
        modalRecommendId = 'tr_modal_recommend-' + getClickCartButtonRequest.catalogItemCode;
      }

      if (typeof Rtoaster !== 'undefined') {
        const rtoasterParameter: RtoasterParameter = {
          appKeys: { ctgry1CdView: Env.PAGE.llCategoryCode, ctgry2CdView: Env.PAGE.lCategoryCode },
          catalogItemCode: SUPPLIER_ID_ASKUL + catalogItemCode
        };

        // 商品詳細画面初期表示時のRtoasterAPIと、カゴ追加時のRtoasterAPIが
        // 競合してしまうため、商品詳細画面初期表示のRtoaster処理中はカゴ追加を待ち合わせる
        let count = 0;
        const waitTimer = setInterval(() => {
          count++;
          if (!RTOASTER_STATUS.isDuringRtoaster || count > MAX_RETRY_COUNT) {
            clearInterval(waitTimer);
            RTOASTER_STATUS.isDuringRtoaster = true;
            doShowRtoaster({
              elementIds: [modalRecommendId],
              showRtoasterAreaCallBack: this.showRtoasterArea.bind(this),
              setParametersCallBack: setParametersCallBack,
              rtoasterParameter: rtoasterParameter
            });
          }
        }, RETRY_INTERVAL);
      }
    }

    /// カゴに入れましたモーダル(ツールチップ)の表示
    AddCartViewModal.view(
      targetElement,
      result.isSameItem,
      result.totalAmount,
      result.totalCount,
      result.itemImageUrl,
      id,
      viewName
    );
  }).catch((error) => {
    const errorCode = error.response.data.errors[0].code;
    const errorMessage = error.response.data.errors[0].message;
    const statusCode = error.response.status;

    // ソロアリで未ログインの場合は簡易ログインページへ遷移する
    if (isSoloare(Env.SITE_TYPE) && statusCode === 400 && errorCode === SOLOARE_ADD_CART_NOT_LOGIN_ERROR_CODE) {
      window.location.href = "/buyer/view/a010/DAA01010.html?directUrl=%2Fbuyer%2Fview%2Fa130%2FDAE01010.html" +
        `%3FsupId%3D${getClickCartButtonRequest.supplierId}%26ctgItemCd%3D${getClickCartButtonRequest.catalogItemCode}%26qtyParam%3D${getClickCartButtonRequest.quantity}`;
      return;
    }

    const message = MessageConverter.errorMessageConverter(errorMessage);

    // それ以外の場合はalertを出して終了
    alert(message);
  });
  }

  /// まとめてカゴ投入ボタン押下処理実行
  static async addCartTogether(
    targetElement: HTMLElement,
    id: string,
    viewName: string,
    items: AsCartItem[]
  ) {
    // YUSP連携 ADD_TO_CARTイベント
    YUSPUtil.register({
      enableAddToCart: {
        catalogItemCodes: items.map(item => item.catalogItemCode),
        quantities: items.map(item => item.quantity)
      }
    });
    /// 集客検索PF.カゴ共通.カゴボタン押下を実行する
    await this.asCartRepository.getClickCartTogetherButton(
      items,
      getSiteTypeValue(),
      AddCartModalAction.getSoloelRcmndFldrIdFromUrl()
    ).then((result) => {

      /// サイト区分 = ソロアリかつ集客検索PF.カゴ共通.カゴボタン押下.isCartRedirectがtrueの場合
      if (isSoloare(Env.SITE_TYPE) && result.isCartRedirect) {
        /// ソロアリフロント画面.DAE01010 カート内商品一覧に遷移する
        window.location.href = result.redirectPath;
        return;
      }

      /// カゴに入れましたモーダル(ツールチップ)の表示
      AddCartViewModal.view(
        targetElement,
        result.isSameItem,
        result.totalAmount,
        result.totalCount,
        result.itemImageUrl,
        id,
        viewName
      );
    }).catch((error) => {
      const errorCode = error.response.data.errors[0].code;
      const errorMessage = error.response.data.errors[0].message;
      const statusCode = error.response.status;

      /// ソロアリで未ログインの場合は簡易ログインページへ遷移する
      if (isSoloare(Env.SITE_TYPE) && statusCode === 400 && errorCode === SOLOARE_ADD_CART_NOT_LOGIN_ERROR_CODE) {
        window.location.href = "/buyer/view/a010/DAA01010.html?directUrl=%2Fbuyer%2Fview%2Fa130%2FDAE01010.html" +
          `%3FsupId%3D${items[0].supplierId}%26ctgItemCds%3D${items.map(item => item.catalogItemCode).join('%2C')}%26qtyParam%3D${items[0].quantity}`;
        return;
      }

      /// それ以外の場合はalertを出して終了
      alert(errorMessage);
    });
  }

  /// 通常のかご追加 Adobe Analyticsトリガーを設定
  static async addCartAnalytics(
    targetElement: HTMLElement,
    addCartButtonRequest: AddCartButtonRequest
  ) {
    const analyticsItem = new AnalyticsItem();
    analyticsItem._supplierId = new SupplierId(addCartButtonRequest.supplierId);
    analyticsItem._catalogItemCode = addCartButtonRequest.catalogItemCode;
    analyticsItem._medicalMaterialType = targetElement.dataset.medicalMaterialType as string;
    analyticsItem._internalCampaignCode = targetElement.dataset.internalCampaignCode as string;
    this.CART_SUBMIT_EVENT.trigger({
      target: targetElement,
      linkName: 'CartAdd',
      analyticsData: {
        items: [analyticsItem]
      }
    });
  }

  private static getSoloelRcmndFldrIdFromUrl(): string | null {
    if (isSoloare(Env.SITE_TYPE)) {
      return new URLSearchParams(window.location.search).get('rcmndFldrId');
    }
    return null;
  }

  /// ポジティブ遷移の計測（PC検索結果画面1ページ目のかご追加）トリガー設定
  private static positiveTransitionsAnalytics(
    targetElement: HTMLElement,
    addCartButtonRequest: AddCartButtonRequest,
  ) {
    /// 必ずページパラメーターが設定されているはずの為、nullになる事は無いが念のため設定する
    const currentPage = window.analyticsData?.paging ?? null;
    const fName = window.analyticsData?.fName ?? null;
    if (!(currentPage === 1 && (fName === 'キーワード検索結果' || fName === '商品検索一覧')) || isSoloare(Env.SITE_TYPE)) {
      /// 通常のかご追加 トリガー設定
      this.addCartAnalytics(targetElement, addCartButtonRequest);
      return;
    }

    const analyticsItem = new AnalyticsItem();
    analyticsItem._supplierId = new SupplierId(addCartButtonRequest.supplierId);
    analyticsItem._catalogItemCode = addCartButtonRequest.catalogItemCode;
    analyticsItem._medicalMaterialType = targetElement.dataset.medicalMaterialType as string;
    analyticsItem._internalCampaignCode = targetElement.dataset.internalCampaignCode as string;
    this.POSITIVE_TRANSITIONS_EVENT.trigger({
      target: targetElement,
      linkName: 'CartAdd',
      analyticsData: {
        items: [analyticsItem]
      }
    });
  }
}
